const urlObj = require("./url")
let utils  = {
  imgURL : process.env.NODE_ENV == "development" 
  ? urlObj.devUrl
  : urlObj.proUrl,
  videoUrl : process.env.NODE_ENV == "development" 
  ? urlObj.devVideoUrl
  : urlObj.proUrl,
};
export default utils;
